import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ResponseModel } from '@dental-ui/account/models';
import { buildApiUrl, buildRequestHeaders } from '@dental-ui/shared/consts';

export interface MachineTypeDto {
  id: string;
  name: string;
  isActive: boolean;
}

export interface PaginationData<T> {
  data: T[];
  totalPage: number;
  totalRecord: number;
}

@Injectable({ providedIn: 'root' })
export class PortalMachineTypesApiService {
  private readonly http = inject(HttpClient);

  getMachineTypes(page: number, pageSize: number, name?: string): Observable<PaginationData<MachineTypeDto>> {
    const body = {
      PaginationRequestModel: {
        page: page + 1,
        numberOfRecord: pageSize,
        sortColumn: 'Name',
        sortOrder: 'asc',
      },
      MachineModelFilterRequestDto: { name: name ?? '' },
    };
    return this.http
      .post<ResponseModel<PaginationData<MachineTypeDto>>>(
        buildApiUrl('machineType.getAllByFilter'),
        body,
        { headers: buildRequestHeaders(true) }
      )
      .pipe(map((res) => res.data ?? { data: [], totalPage: 0, totalRecord: 0 }));
  }

  getAllMachineTypes(): Observable<MachineTypeDto[]> {
    return this.http
      .get<ResponseModel<MachineTypeDto[]>>(buildApiUrl('machineType.getAll'), {
        headers: buildRequestHeaders(true),
      })
      .pipe(map((res) => res.data ?? []));
  }

  createMachineType(model: Omit<MachineTypeDto, 'id'>): Observable<unknown> {
    return this.http.post(buildApiUrl('machineType.create'), model, {
      headers: buildRequestHeaders(true),
    });
  }

  updateMachineType(model: MachineTypeDto): Observable<unknown> {
    return this.http.put(buildApiUrl('machineType.update'), model, {
      headers: buildRequestHeaders(true),
    });
  }

  deleteMachineType(id: string): Observable<unknown> {
    return this.http.delete(`${buildApiUrl('machineType.delete')}?machineType=${id}`, {
      headers: buildRequestHeaders(true),
    });
  }
}
